'use client'

import React from 'react'

import type {CaptchaRenderProps} from '@/src/features/auth/core/login-types'
import {FormTemplate} from '@/src/shared/modules/form'

import {InvisibleCaptcha} from '@/src/shared/modules/captcha'
import Button from '@/src/shared/ui/button'
import {FormInput} from '@/src/shared/ui/inputs/input'
import {Label} from '@/src/shared/ui/label'
import {AsyncProcessLoading} from '@/src/shared/ui/layout/ui/async-loading'

import {Container} from './login.styled'
import styled from 'styled-components'

type CodeFormProps = {
  isPending: boolean
  isTokenReady: boolean
  remaining: number
  onSubmit: () => void
  onBack: () => void
  captchaProps: CaptchaRenderProps
}

export const CodeForm = ({isPending, isTokenReady, remaining, onSubmit, onBack, captchaProps}: CodeFormProps) => (
  <FormTemplateStyled title="Введите код">
    {isPending && <AsyncProcessLoading />}

    <InvisibleCaptcha {...captchaProps} key={captchaProps.renderKey} />

    <Container>
      {remaining > 0 && <Label>Отправить снова через: {remaining}</Label>}
      <FormInput
        data-testid="code-input"
        name="code"
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            onSubmit()
          }
        }}>
        Код
      </FormInput>
      {remaining === 0 && <Button onClick={onBack}>Изменить номер телефона и отправить снова</Button>}
      <Button data-testid="login-btn" onClick={onSubmit} disabled={!isTokenReady} loading={!isTokenReady}>
        Отправить
      </Button>
    </Container>
  </FormTemplateStyled>
)

const FormTemplateStyled = styled(FormTemplate)`
    & ${FormTemplate.__UI.Form} {
      max-width: 465px;
    }
`